<template>
  <v-dialog v-model="deleteStudentsConfirmation" persistent max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn
        color="red darken-1"
        :dark="Boolean(selected.length)"
        class="mr-3"
        :disabled="!selected.length"
        v-on="on"
      >
        un-enroll selected
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Un-enroll selected students from the class</span>
      </v-card-title>
      <v-card-text>
        Note that once confirmed, lesson results for those students will be
        lost.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="deleteStudentsConfirmation = false">Close</v-btn>
        <v-btn color="red darken-1" text @click="unenrollStudents">
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { map } from 'lodash'
import ClassInvitation from '@/modules/class/models/ClassInvitation'
import { mapMutations } from 'vuex'

export default {
  name: 'UnenrollButton',
  props: {
    selected: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      deleteStudentsConfirmation: false
    }
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar', 'showErrorSnackbar']),
    async unenrollStudents() {
      const ids = map(this.selected, selected => selected.id)

      try {
        await ClassInvitation.dispatch('batchDeleteClassInvitation', {
          classInvitationIds: ids
        })
        this.showErrorSnackbar('Students were removed from the class.')
      } catch (error) {
        this.showErrorSnackbar('There was a server error. Contact support')
      }

      this.deleteStudentsConfirmation = false
    }
  }
}
</script>
